import React from "react";
import { useDocumentCategories } from "newui/store/common-types";
import { SelectWithLabel, BaseSelectWithLabelProps, SelectOption } from "../InputWithLabel/SelectWithLabel";
import { useFormikFieldState } from "./useFormikField";
import { useField, useFormikContext } from "formik";
import { useCurrentCompanyValue } from "hooks/auth";

interface DocumentCategorySelectProps
  extends Omit<BaseSelectWithLabelProps, "options" | "isLoading"> {
  excludeCurrentProfileType?: boolean;
  excludeProfileType?: number | null;
}

export const DocumentCategorySelect = ({
  label = "Document Category",
  placeholder = "Select category",
  excludeProfileType = null,
  onChange: onChangeProp,
  hasError: hasErrorProp,
  errorText: errorTextProp,
  value: valueProp,
  name,
  excludeCurrentProfileType = false,
  ...rest
}: DocumentCategorySelectProps) => {

  const formik = useFormikFieldState(name);
  const [field, meta] = useField<number>({ name });
  const { setFieldValue } = useFormikContext<Record<string, number | null>>();
  const currentCompanyProfileId = useCurrentCompanyValue<"profile_type">("profile_type")?.id ?? null;

  const handleChange = (selected: SelectOption | null) => {
    formik.markTouched();
    setFieldValue(name, selected?.value, true);
    onChangeProp?.(selected);
  };

  const selectedValue = valueProp ?? field.value;

  const { values, isLoading } = useDocumentCategories(excludeProfileType ?? (excludeCurrentProfileType ? currentCompanyProfileId : null), "categories");
  return (
    <SelectWithLabel
      options={values as SelectOption[]}
      isLoading={isLoading}
      label={label}
      placeholder={placeholder}
      value={valueProp ?? values.find((option) => option.value === selectedValue) ?? null}
      name={name}
      hasError={hasErrorProp || formik.hasError}
      errorText={errorTextProp || formik.errorText}
      onChange={handleChange}
      {...rest}
    />
  );
};
